"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const FileUtils_1 = require("./FileUtils");
const mobx_1 = require("mobx");
const LoaderShelf_1 = require("../../global/shelves/LoaderShelf");
class ImagePickerShelf {
    constructor(uploadImage, options) {
        this.localFile = null;
        this.uploadedImage = null;
        this.errorMsg = null;
        this.loader = new LoaderShelf_1.default();
        this.setErrorMsg = (errorMsg) => {
            this.errorMsg = errorMsg;
        };
        this.setUploadedImage = (uploadedImage) => {
            this.uploadedImage = uploadedImage;
        };
        this.setLocalFileAndCraftBuffer = (file) => {
            this.localFile = file;
            if (file) {
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                FileUtils_1.craftImageBuffer(file, 1000, this.upload);
            }
        };
        this.onFileInputResolve = (file) => {
            this.setLocalFileAndCraftBuffer(file);
        };
        this.pick = () => {
            FileUtils_1.openFileInput(this.onFileInputResolve, this.setErrorMsg, "image/*");
        };
        this.upload = (buffer) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.loader.start();
            this.setErrorMsg(null);
            try {
                const image = yield this.uploadImage(buffer, null);
                mobx_1.runInAction(() => {
                    this.uploadedImage = image;
                });
            }
            catch (err) {
                // TODO - Show error message / treat error
                this.setErrorMsg((err === null || err === void 0 ? void 0 : err.message) || err || "Error uploading");
            }
            finally {
                this.loader.end();
            }
        });
        this.getPickerFields = () => ({
            src: this.src,
            pick: this.pick,
            setUploadedImage: this.setUploadedImage,
            uncertainfiedImage: this.uncertainfiedImage,
            loading: this.loader.isLoading,
        });
        this.uploadImage = uploadImage;
        if (options && options.initialImage) {
            this.uploadedImage = options.initialImage;
        }
        mobx_1.makeAutoObservable(this);
    }
    get src() {
        return ((this.localFile && URL.createObjectURL(this.localFile)) ||
            (this.uploadedImage && this.uploadedImage.url));
    }
    get uncertainfiedImage() {
        if (this.uploadedImage) {
            return {
                image: this.uploadedImage,
                bytes: null,
            };
        }
        return null;
    }
}
exports.default = ImagePickerShelf;
